const KEY_PREFIX = 'getting-started-completed'

const getKey = (uniName: string) => `${KEY_PREFIX}:${uniName}`

export const isGettingStartedCompleted = (uniName: string) =>
  localStorage.getItem(getKey(uniName)) === 'true'

export const markGettingStartedCompleted = (uniName: string) =>
  localStorage.setItem(getKey(uniName), 'true')
